import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { MaterialHero } from "../../components/static-page-components/material-hero";
import EastIcon from "@mui/icons-material/East";
import { Link } from "react-router";
import { Pages } from "../../utils";
import applicationImage from "../../assets/design-hub/lead-generation-d.jpg";
import applicationImage2 from "../../assets/design-hub/lead-generation-m.jpg";
import affiliateImage from "../../assets/design-hub/affiliate.jpg";
import chatterImage from "../../assets/design-hub/chatter.jpg";
import listImage from "../../assets/design-hub/list.jpg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import platformImage from "../../assets/design-hub/reviews.jpg";
import { SplitScreenBlock } from "../../components/static-page-components/split-screen-block";
import "./styles.scss";
import { SealIcon } from "../../components/seal-icon";

const AffiliateType = ({ text }: { text: string }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <CheckCircleIcon className="text-green" />
        <Typography variant="body1">{text}</Typography>
      </Stack>
    </Box>
  );
};

const PlatformBlock = ({
  title,
  description,
  to,
}: {
  title: string;
  description: string;
  to: string;
}) => {
  return (
    <Grid2
      className="platform-block"
      size={{
        xs: 12,
        md: 4,
      }}
    >
      <Stack spacing={2} className="content">
        <SealIcon color="#00a06d" />
        <Typography mb="16px" variant="h5" className="text-pink margin-0">
          {title}
        </Typography>
        <Typography mb="20px" variant="body1" className="margin-0">
          {description}
        </Typography>
        <div className="c2a-container">
          <Button
            component={Link}
            to={to}
            variant="text"
            color={"purple" as any}
            endIcon={<EastIcon />}
            className="thin "
          >
            <Typography variant="body1" component="span">
              View More
            </Typography>
          </Button>
        </div>
      </Stack>
    </Grid2>
  );
};

export const AboutDesignHubPage = () => {
  return (
    <div className="page design-hub-page">
      <MaterialHero title="DESIGNER HUB" />

      <LandingPageSection className="text-center">
        <Typography
          component="h2"
          variant="h4"
          className="section-title font-body"
          mb="16px !important"
        >
          Matching Dashboard
        </Typography>
        <Typography
          variant="body1"
          className="section-subtitle"
          mb="28px !important"
          sx={{ maxWidth: "600px !important" }}
        >
          Stop chasing down client leads in multiple places. Our matching
          dashboard keeps HDG leads and communication organized and accessible
          from the palm of your hand.
        </Typography>
        <Stack
          className="contain-text"
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={{
            xs: 1,
            sm: 2,
            md: 3,
          }}
          justifyContent={"center"}
        >
          <Button
            className="design-hub-account-c2a font-size-3"
            size="large"
            style={{ flex: "1 1 0px" }}
            variant="outlined"
            endIcon={<EastIcon />}
            component={Link}
            to={Pages.SIGNUP}
          >
            Create an Account
          </Button>
          <Button
            className="design-hub-account-c2a font-size-3"
            size="large"
            endIcon={<EastIcon />}
            component={Link}
            to={Pages.LOGIN}
            variant="contained"
          >
            Log In
          </Button>
        </Stack>
      </LandingPageSection>

      <div className="landing-page-image">
  <div className="site-wrapper">
  <picture>
  <source media="(max-width: 768px)" srcSet={applicationImage2} />
  <source media="(min-width: 769px)" srcSet={applicationImage} />
  <img
    src={applicationImage}
    alt="home design guild application screenshot"
    className="full-width-image"
  />
</picture>
  </div>
</div>


      <LandingPageSection className="text-center design-community-section">
        <Typography
          variant="overline"
          className="margin-0 section-sub-heading text-purple"
        >
          DESIGNER HUB
        </Typography>
        <Typography
          component="h2"
          variant="h4"
          className="font-body text-pink margin-top-0"
          mb="12px !important"
        >
          Streamlined For Success
        </Typography>
        <Typography variant="body1" className="section-subtitle contain-text-small">
          Our Designer Hub is your centralized hub for managing your membership
          – set it once or as many times as you want to to and watch your
          matching pipeline grow.
        </Typography>
      </LandingPageSection>

      <div id="chatter">
        <SplitScreenBlock
          image={chatterImage}
          titleClassName="font-body"
          title="Easy, Peasy"
          description="You don’t have to be a tech wizard or marketing savant to use our tool. Our Designer Hub hand walks you through the onboarding process with out complexity."
          // to={Pages.COMING_SOON}
          // linkText="See More"
          backgroundImage
        />
      </div>
      <div id="thelist">
        <SplitScreenBlock
          image={affiliateImage}
          titleClassName="font-body"
          title="Centralize Your Efforts"
          description="Manage your matches in one place, from a quick glance to diving into the details. All communication and progress with each match is all here."
          // to={Pages.SIGNUP}
          // linkText="Apply to Get Started"
          backgroundImage
          reverse
        />
      </div>
      <SplitScreenBlock
        image={listImage}
        titleClassName="font-body"
        title="We Evolve With You"
        description="Easily update your Designer Bio, your Designer Files Gallery and your Matching Profile at any time."
        // to={Pages.COMING_SOON}
        // linkText="Submit a Partner Request"
        backgroundImage
      />

      <LandingPageSection className="affilate-type-section" id="affiliates">
        <Typography
          component="h2"
          variant="h4"
          className="font-body text-pink text-center margin-top-0"
          sx={{
            mb: "30px",
          }}
        >
          Our Affiliate Types
        </Typography>
        <Stack
          className="affiliate-types-grid"
          direction={{ xs: "column", sm: "row" }}
          flexWrap={"wrap"}
          spacing={"32px"}
          justifyContent={"center"}
        >
          <Stack spacing={"18px"}>
            <AffiliateType text="3D Design & Rendering" />
            <AffiliateType text="Client Relationship Coaching" />
            <AffiliateType text="Procurement" />
          </Stack>
          <Stack spacing={"18px"}>
            <AffiliateType text="Bookeeping Services" />
            <AffiliateType text="Project Management" />
            <AffiliateType text="Virtual Assistant" />
          </Stack>
          <Stack spacing={"18px"}>
            <AffiliateType text="Website Design" />
            <AffiliateType text="Business Coaching" />
            <AffiliateType text="Manufacturer Discount" />
          </Stack>
        </Stack>
      </LandingPageSection>

      <LandingPageSection className="platform-that-pays-seciton" id="get-paid">
        <Typography
          variant={"display2" as any}
          component="h2"
          className="text-pink section-title text-center font-title"
          sx={{
            mb: "16px !important",
          }}
        >
          THE PLATFORM THAT PAYS YOU
        </Typography>
        <Typography
          variant="body1"
          className="section-subtitle text-center contain-text-small"
          sx={{
            maxWidth: "768px",
            mx: "auto",
            mb: "62px !important",
          }}
        >
          Every designer we talk to is looking for additional ways to fuel their
          revenue stream. With Home Design Guild we provide you with
          opportunities to earn more utilizing work you already do.
        </Typography>
        <img
          className="full-width-image"
          src={platformImage}
          alt="designers hub view in the home design guild application"
         
        />

        <Grid2 container columns={12} spacing={6} className="platform-blocks">
          <PlatformBlock
            title="Profit Share"
            description="Design Membership Members share 10% of the profit from our Homeowner Memberships. Must meet minimum DESIGNER FILE requirements to be eligible."
            to={Pages.COMING_SOON}
          />
          <PlatformBlock
            title="Earn Commission"
            description="Earn up to $325 for every project that is financed through our Home Design Guild Financing Program."
            to={Pages.FINANCING}
          />
          <PlatformBlock
            title="Designer Referral Program"
            description="Members have the opportunity to refer interior designer and decorator colleagues to Home Design Guild for an opportunity to earn membership credits. Referred designers must be approved and have paid their membership in full."
            to={Pages.COMING_SOON}
          />
        </Grid2>
      </LandingPageSection>

      <LandingPageSection className="pink-section text-center">
        <Typography
          variant="h4"
          className="font-body title margin-top-0"
          mb="20px"
        >
          Start Fueling Your Future With Home Design Guild.
        </Typography>
        <Typography
          variant="body2"
          className="section-subtitle contain-text"
          mb="28px"
        >
          Join now and experience the difference a designer-first platform can
          make.
        </Typography>
        <Button
          color={"white" as any}
          variant="contained"
          component={Link}
          to={Pages.SIGNUP}
          className="font-size-4"
        >
          Apply Now
        </Button>
      </LandingPageSection>
    </div>
  );
};
